import { useInViewport } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import styles from './styles.module.less';

const BlurryLoadingImage = ({ thumb, src, alt, divStyleClass = '', style, ...props }: any) => {
  const key = src?.split('/')?.slice(-2)?.join('_'); // 获取相对路径的最后两部分并用_拼接
  const localThumb = thumb || (window as any).lqipmap?.[key];
  if (!localThumb) {
    return (
      <img
        style={{
          ...(style || {})
        }}
        loading="lazy"
        src={src}
        alt={alt}
        {...props}
        className={classNames(styles.placeholder, divStyleClass, props.className)}
      />
    );
  }
  return (
    <LazyLoadImage thumb={localThumb} src={src} alt={alt} divStyleClass={divStyleClass} style={style} {...props} />
  );
};
const LazyLoadImage = ({ thumb, src, alt, divStyleClass = '', style, ...props }: any) => {
  const [currentImage, setCurrentImage] = useState(thumb);
  const [loading, setLoading] = useState(true);
  const [noPrevice, setNoPrevice] = useState(false);
  const ref = useRef(null);
  const [inViewport] = useInViewport(ref);
  const fetchImage = src => {
    const loadingImage = new Image();
    loadingImage.src = src;
    const start = performance.now();
    loadingImage.onload = () =>
      requestAnimationFrame(() => {
        setNoPrevice(performance.now() - start > 100);
        setCurrentImage(loadingImage.src);
        setLoading(false);
      });
  };

  useEffect(() => {
    inViewport && fetchImage(src);
  }, [inViewport]);

  return (
    <img
      ref={ref}
      style={{
        ...(style || {}),
        filter: `${loading ? 'blur(10px)' : ''}`,
        transition: !noPrevice ? 'none' : '1s filter ease'
      }}
      loading="lazy"
      src={currentImage}
      alt={alt}
      {...props}
      className={classNames(styles.placeholder, divStyleClass, props.className)}
    />
  );
};

export default BlurryLoadingImage;
